import React, {useEffect} from "react"
import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom"
import {LoginForm} from "./components/LoginForm"
import {ProtectedRoute, PublicRoute} from "./components/Route"
import DeviceDashboard from "./screens/DeviceDashboard"
import {useAuthStore} from "./store/authStore"

function App() {
	const {initializeAuth} = useAuthStore()

	useEffect(() => {
		initializeAuth()
	}, [initializeAuth])

	return (
		<BrowserRouter>
			<div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
				<Routes>
					<Route
						path="/"
						element={
							<ProtectedRoute>
								<DeviceDashboard />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/login"
						element={
							<PublicRoute>
								<LoginForm />
							</PublicRoute>
						}
					/>
					<Route path="*" element={<Navigate to="/" replace />} />
				</Routes>
			</div>
		</BrowserRouter>
	)
}

export default App
